import { InvoicesStatus, InvoiceStatusTextKeys } from './types.ts'

export const INVOICE_STATUS_CONFIG: Record<
  InvoicesStatus,
  {
    color: 'green' | 'yellow'
    textKey: InvoiceStatusTextKeys
  }
> = {
  [InvoicesStatus.BREAK_EVEN]: {
    color: 'green',
    textKey: 'neutral'
  },
  [InvoicesStatus.IS_GETTING_MONEY_BACK]: {
    color: 'green',
    textKey: 'open'
  },
  [InvoicesStatus.HAS_UNPAID_INVOICES]: {
    color: 'yellow',
    textKey: 'open'
  },
  [InvoicesStatus.DIRECT_DEBIT]: {
    color: 'green',
    textKey: 'directDebit'
  },
  [InvoicesStatus.DIRECT_DEBIT_WITH_UNPAID_INVOICES]: {
    color: 'yellow',
    textKey: 'open'
  }
}
